//https://stackoverflow.com/questions/6393943/convert-javascript-string-in-dot-notation-into-an-object-reference

//maybe us a lib? => https://github.com/justinlettau/ts-dot-prop

/**
 * 
 * @param obj the complex object
 * @param is ex. "a.b.c"
 * @param value 
 * @returns 
 */
export function StringDotToObject(obj, is, value?) {
    if (typeof is == 'string')
        return StringDotToObject(obj, is.split('.'), value);
    else if (is.length == 1 && value !== undefined)
        return obj[is[0]] = value;
    else if (is.length == 0)
        return obj;
    else {

        if (obj[is[0]] == null)
            return null;

        return StringDotToObject(obj[is[0]], is.slice(1), value);
    }
}